export default __webpack_public_path__ + "static/media/Setting_line_light.ce60c384.svg";